<x-chartist [type]="'Line'" [data]="biPolarLineData" [options]="biPolarLineOptions" class="height-300">
</x-chartist>